import React from 'react';

function Widget({title,children}) {
    return (
        <div className="widget-item">
            <h3 className="widget-title">{title}</h3>
            <div className="widget-body">
                {children}
            </div>
        </div>
    );
}

export default Widget;